import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const SignsCustomSoftware6 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="signsCustomSoftware" section="signs">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="signsCustomSoftware:signs" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default SignsCustomSoftware6;
